/* eslint-disable react/require-default-props,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import styles from './index.styl';

import { getText } from '../../../utils/ui/getText';

const renderErrors = (errors, formatMessage) => {
  if (Array.isArray(errors)) {
    return errors.map((error, i, arr) => {
      const isLastItem = i < arr.length - 1;
      return (
        <div key={i} className={cn({ mb1: isLastItem })}>
          {getText(error, formatMessage)}
        </div>
      );
    });
  }

  return errors;
};

const ErrorBlock = ({ errors, style, className, intl }) => (
  <div
    className={cn('ErrorBlock', className)}
    styleName="errorMsg"
    style={style}
  >
    {renderErrors(errors, intl.formatMessage)}
  </div>
);

ErrorBlock.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.node,
  ]),
  style: PropTypes.object,
  className: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(ErrorBlock, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/common/ErrorBlock/index.jsx